var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a3a3c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,176H4a4,4,0,0,1,0-8H32a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188,176H64a4,4,0,0,1,0-8H188a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48,192a20,20,0,1,1,20-20A20,20,0,0,1,48,192Zm0-32a12,12,0,1,0,12,12A12,12,0,0,0,48,160Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,100H4a4,4,0,0,1,0-8H128a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188,100H160a4,4,0,0,1,0-8h28a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144,116a20,20,0,1,1,20-20A20,20,0,0,1,144,116Zm0-32a12,12,0,1,0,12,12A12,12,0,0,0,144,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72,24H4a4,4,0,0,1,0-8H72a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188,24H104a4,4,0,0,1,0-8h84a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88,40a20,20,0,1,1,20-20A20,20,0,0,1,88,40ZM88,8a12,12,0,1,0,12,12A12,12,0,0,0,88,8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.63a4ed65a8dcf44a022814e7145722de.svg";
export { ForwardRef as ReactComponent };